import React from "react"
import { useTaskReportExportContext } from "contexts/TaskReportExportContext"
import { Checkbox } from "shared/checkboxes"

const OPEN_TASKS_IDENTIFIER = "task-report-export-include-open-tasks"
const CLOSED_TASKS_IDENTIFIER = "task-report-export-include-closed-tasks"

const NewTaskReportExportTaskStatuses = () => {
  const {
    includeClosedTasks,
    includeOpenTasks,
    noTaskStatusIncluded,
    toggleClosedTasks,
    toggleOpenTasks,
  } = useTaskReportExportContext()

  return (
    <>
      <div className="flex items-center mb-2">
        <Checkbox
          className="mr-4"
          onChange={toggleOpenTasks}
          uuid={OPEN_TASKS_IDENTIFIER}
          value={includeOpenTasks}
        />
        <label className="cursor-pointer" htmlFor={OPEN_TASKS_IDENTIFIER}>
          Open
        </label>
      </div>
      <div className="flex items-center">
        <Checkbox
          className="mr-4"
          onChange={toggleClosedTasks}
          uuid={CLOSED_TASKS_IDENTIFIER}
          value={includeClosedTasks}
        />
        <label className="cursor-pointer" htmlFor={CLOSED_TASKS_IDENTIFIER}>
          Closed
        </label>
      </div>
      {
        noTaskStatusIncluded && (
          <p className="text-xs text-error mt-2">
            An export must include open tasks, closed tasks, or both.
          </p>
        )
      }
    </>
  )
}

export default NewTaskReportExportTaskStatuses
